import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import FORMATTERS from 'helpers/formatters';
import {
  CustomCard,
  CustomCardBody,
} from '_components/Settings/components/SettingsV2/styles';

import { Badge, Text } from './styles';

function ChargeHeader({ charge }) {
  let message = '';

  switch (charge.status_description.toLowerCase()) {
    case 'pendente':
      message = 'Aguardando pagamento';
      break;
    case 'aguardando provedor':
      message = 'Em processamento';
      break;
    case 'aguardando pagamento':
      message = 'Aguardando pagamento';
      break;
    case 'recebida':
      message = `Recebida em ${FORMATTERS.DATE_DDMMYYYY(charge.payment_date)}`;
      break;
    case 'vencida':
      message = 'Vencida';
      break;
    case 'erro provedor':
      message = 'Erro no provedor';
      break;
    case 'cancelada':
      message = 'Cancelada';
      break;
    default:
      break;
  }

  return (
    <Row className="mt-3">
      <Col>
        <CustomCard>
          <CustomCardBody className="d-flex align-items-center">
            <span className="d-flex align-items-center">
              <Badge status={charge.status_variant} />
              <Text className="m-0 ml-3">{message}</Text>
            </span>
          </CustomCardBody>
        </CustomCard>
      </Col>
    </Row>
  );
}

ChargeHeader.defaultProps = {
  charge: null,
};

ChargeHeader.propTypes = {
  charge: PropTypes.object,
};

export default ChargeHeader;
